export default __webpack_public_path__ + "static/media/logo.dc91e6db.png";